/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useEffect } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Apps, Tasks } from "../../Constant";
import { useAppDispatch } from "../../Redux-Toolkit/Hooks";
import { setActiveTab, setAllTask } from "../../Redux-Toolkit/Reducers/TaskSlice";
import { TaskApi } from "../../api";
import NavClass from "./NavClass";
import TabClass from "./TabClass";
import { toast, ToastContainer } from "react-toastify";

const TaskContainer = () => {
  const dispatch = useAppDispatch();

  const getTask = async () => {
    try {
      await axios.get(TaskApi).then((resp) => {
        dispatch(setAllTask(resp.data));
      });
    } catch (error) {
      toast.error("error"+ error);
    }
  };

  useEffect(() => {getTask()}, []);
  const activeToggle = (tab: string) => dispatch(setActiveTab(tab));

  return (
    <>
      <Breadcrumbs pageTitle={Tasks} parent={Apps} title={Tasks} />
      <Container fluid>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <NavClass activeToggle={activeToggle} />
            <TabClass />
          </Row>
        </div>
        <ToastContainer/>
      </Container>
    </>
  );
};

export default TaskContainer;
